// extracted by mini-css-extract-plugin
export var checkbox = "_3l-0";
export var circle = "_3l-3";
export var horizontalContainer = "_3l-7";
export var sm = "_3l-5";
export var switch0 = "_3l-2";
export var switchDisabled = "_3l-8";
export var switchEnabled = "_3l-1";
export var textSwitchContainer = "_3l-9";
export var textSwitchOption = "_3l-a";
export var textSwitchOptionSelected = "_3l-b";
export var verticalContainer = "_3l-6";
export var xs = "_3l-4";